import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import "./RatingsModal.scss";
import { t } from "i18next";
import Rating from '@mui/material/Rating';
import CloseIcon from '@mui/icons-material/Close';
import { API_RESPONSE } from "../../../../Utilities/Constants/Constants";

const RatingsModal = (props:any) => {
      console.log(props)

      const onClose = ()=>{
        props.dialogStatus(API_RESPONSE.FALSE);
      }
    return (
        <div className="ratings-wrapper">
            <Dialog
        // fullScreen={fullScreen}
        open={props.modalState}
        // onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="rating-dialog-box"
      >
        <DialogTitle id="responsive-dialog-title">
            {/* <div className="title-wrapper"> */}
               User Feedback
                <CloseIcon className="close-icon" onClick={onClose}/>
            {/* </div> */}
           
        </DialogTitle>
        <DialogContent>
            <div className="dialog-content-wrapper">
                <div className="rating-inp-wrap">
                <label className="rating-label">Rating</label>
                <Rating name="half-rating" value={props?.content?.rating}
                                            onChange={(event, newValue) => {
                                                // setRatingData(newValue);
                                            }}
                                            readOnly 
                                            precision={1}
                                             className="rating__icon" size="large" />
                </div>
                <div className="rating-inp-wrap">
                <label className="rating-label">Feedback</label>
                   <p>{props?.content?.feedback}</p>
                </div>
            </div>
            
        </DialogContent>
      </Dialog>
        </div>
    )
};

export default RatingsModal;